export default {
  show: 'Mostrar'
}

export const en = {
  show: 'Show'
}

export const ca = {
  show: 'Mostrar'
}
